import { HIVE_STATIC_VERSION } from "root/widgets/constants";

export const requiredDependencies = ['enquiryService'];

export const defaultAgentLogo = `https://cdn.pgimgs.com/hive-ui/static/${HIVE_STATIC_VERSION}/pg-icons/agent.svg`;

export const editProfileIcon = `https://cdn.pgimgs.com/hive-ui/static/${HIVE_STATIC_VERSION}/pg-icons/font/v3/edit-pencil-o.svg`;
